<template>
  <div
    v-if="!$yhcefs.$userInputData.isContainUnavailableArea"
    class="yhc-ef-item-list-wrapper"
  >
    <p class="text-center yhc-ef-item-list--description">
      枠内をクリックして家財選択画面にお進みください。
    </p>
    <div class="yhc-ef-item-list">
      <!-- すでに追加されたものを表示 -->
      <YhcEFItemListItem
        v-for="(kazaiData, kazaiDataId) in $yhcefs.$userInputData.userAddedKazaiDataById"
        :key="kazaiDataId"
        :kazaiData="kazaiData"
      />
      <!-- 新規追加 button -->
      <YhcEFItemListAddNewKazaiArea />
    </div>
    <p class="text-right pr-1">※表示価格は全て税込です。</p>
    <div
      v-if="$yhcefs.$userInputData.isKaguidoOptionAvailable"
      class="yhc-ef-item-list--option-info"
    >
      <p class="option-title">お得な同時サービス！</p>
      <p class="option-description">
        一緒にお部屋の家具移動など、<span class="bold">ちょこっと模様替え</span
        >オプションが<span class="highlight">お安く</span>ご利用いただけます！
      </p>
      <a
        href="#"
        class="detail-link hover-fade"
        @click.prevent="scrollToKaguidoOption"
        >詳細はこちら ≫</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import YhcEFItemListAddNewKazaiArea from './YhcEFItemListAddNewKazaiArea.vue'
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'
import YhcEFItemListItem from './YhcEFItemListItem.vue'
import { overDeliverableItemCountsMessage } from '../peakSeasonAlertMessages'
import { isDeliverableItemCountsExceeded } from '../peakSeasonRuleUtils'

export default {
  name: 'YhcEstimateFormItemList',
  components: { YhcEFItemListItem, YhcEFItemListAddNewKazaiArea },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    addedKazaiCount(): number {
      return Object.keys(this.$yhcefs.$userInputData.userAddedKazaiDataById).length
    },
  },
  data() {
    return {
      formItemList: this.value,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.formItemList = val
      },
      deep: true,
    },
    addedKazaiCount(newCount, oldCount) {
      // 家財点数が減った場合には何もしない
      if (newCount <= oldCount) {
        return
      }
      // 繁忙期シーズンで追加家財数が輸送可能点数を超えていたらモーダルを表示する
      const rule = this.$yhcefs.$userInputData.deliveryPeakSeasonRule
      if (isDeliverableItemCountsExceeded(rule, newCount)) {
        const message = overDeliverableItemCountsMessage(rule!)
        if (message) {
          $core.$toast.alertDialog(message)
        }
      }
    },
  },
  methods: {
    scrollToKaguidoOption() {
      // 家具移動オプションへスクロールする
      const element = document.getElementById('yhc-ef-kaguido-option')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
  },
}
</script>
<style lang="scss">
.yhc-ef-item-list-wrapper {
  padding: 0 var(--yhc-pad);

  .yhc-ef-item-list--description {
    font-size: 18px;

    @media screen and (max-width: 757px) {
      font-size: 16px;
    }
  }

  .yhc-ef-item-list--option-info {
    margin-top: 15px;
    padding: 15px;
    background-color: #f0f8ff; // 薄い青色の背景
    border: 2px solid var(--yhc-color);
    border-radius: 8px;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);

    .option-title {
      font-size: 18px;
      font-weight: bold;
      color: var(--yhc-color);
      margin-bottom: 8px;
    }

    .option-description {
      font-size: 16px;
      line-height: 1.4;
      margin-bottom: 10px;

      .highlight {
        font-weight: bold;
        color: #ff4500; // 目立つ色（オレンジレッド）
      }
    }
  }

  .detail-link {
    display: inline-block;
    color: #ffffff;
    background-color: var(--yhc-color);
    padding: 8px 15px;
    border-radius: 20px;
    text-decoration: none;
    font-weight: bold;
    transition: background-color 0.3s;
  }
}
</style>
